'use strict';

angular.module('pmtPlacesApp.services').service('Geo', [
	function () {
		const toRad = function (x) {
			return (x * Math.PI) / 180;
		};

		const _calculateDistance = function (lat1, lon1, lat2, lon2) {
			try {
				const R = 6371; // km
				const dLat = toRad(lat2 - lat1);
				const dLon = toRad(lon2 - lon1);

				const a =
					Math.sin(dLat / 2) * Math.sin(dLat / 2) +
					Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
				const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
				const d = R * c;

				return d * 1000;
			} catch {
				return NaN;
			}
		};

		return {
			calculateDistance: _calculateDistance
		};
	}
]);
